import type Account from '@/services/models/Account'
import { defineStore } from 'pinia'
import { identifyUser } from '@/plugins/launchdarkly'

interface State {
  account: Account | null
}

const useAccountStore = defineStore('account', {
  state: (): State => ({
    account: null,
  }),
  actions: {
    setAccount(account: Account): void {
      identifyUser(account.username)
      this.account = account
    },
    clearAccount(): void {
      this.account = null
    },
  },
})

export default useAccountStore
